export default __webpack_public_path__ + "static/logo_alt-6812bb92a1107206c70733898bc7d083.png";